import React, { createContext, useContext, useState } from 'react';
import { INITIAL_REGION_INFO } from './initialState';

const RegionContext = createContext();

export const RegionProvider = ({ children }) => {
  const [selectedRegionInfo, setSelectedRegionInfo] = useState(INITIAL_REGION_INFO);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [activeRegion, setActiveRegion] = useState(null);
  const [selectedRegionNames, setSelectedRegionNames] = useState({});

  const resetRegionState = () => {
    setSelectedRegionInfo(INITIAL_REGION_INFO);
    setSelectedRegions([]);
    setSelectedCities([]);
    setActiveRegion(null);
    setSelectedRegionNames({});
  };

  return (
    <RegionContext.Provider
      value={{
        selectedRegionInfo, setSelectedRegionInfo,
        selectedRegions, setSelectedRegions,
        selectedCities, setSelectedCities,
        activeRegion, setActiveRegion,
        selectedRegionNames, setSelectedRegionNames,
        resetRegionState,
      }}
    >
      {children}
    </RegionContext.Provider>
  );
};

export const useRegionContext = () => useContext(RegionContext);
